import {
  initialState,
  Actions,
  State,
  GET_GROUP_SUBSCRIBERS,
  GET_GROUP_SUBSCRIBERS_SUCCESS,
  GET_GROUP_SUBSCRIBERS_ERROR,
  RESET_GROUP_SUBSCRIBERS,
} from "../../types/group/get-group-subscribers";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_GROUP_SUBSCRIBERS:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_GROUP_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_GROUP_SUBSCRIBERS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: true,
          success: false,
        },
      };
    case RESET_GROUP_SUBSCRIBERS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
